import React, { useEffect, useState } from 'react';
import '../styles/partners.css';
import { fetchPartners } from '../../../../common/services/partner';
import { Partner } from '../../../../common/services/partner.types';

function PartnersSection() {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPartners = async () => {
      setLoading(true);
      try {
        const data = await fetchPartners();
        setPartners(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    loadPartners();
  }, []);

  return (
    <section className="partners-section">
      <div className="partners-container">
        <h2 className="partners-title">Our Partners</h2>
        {loading ? (
          <div className="partners-loading">Loading...</div>
        ) : (
          <div className="partners-logos-grid">
            {Array.isArray(partners) && partners.map((partner, idx) => (
              <div className="partner-logo-wrapper" key={idx}>
                <img src={partner.imageUrl} alt={`Partner ${idx + 1}`} className="partner-logo" />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default PartnersSection; 